import {CALL_API} from 'redux-api-middleware';
import {
  DYNAMIC_DATA_GET_REQUEST,
  DYNAMIC_DATA_GET_SUCCESS,
  DYNAMIC_DATA_GET_FAILURE,
  DYNAMIC_DATA_GET_ENTITY_REQUEST,
  DYNAMIC_DATA_GET_ENTITY_SUCCESS,
  DYNAMIC_DATA_GET_ENTITY_FAILURE,
  DYNAMIC_DATA_GET_ORG_ENTITY_REQUEST,
  DYNAMIC_DATA_GET_ORG_ENTITY_SUCCESS,
  DYNAMIC_DATA_GET_ORG_ENTITY_FAILURE,
  DYNAMIC_DATA_POST_REQUEST,
  DYNAMIC_DATA_POST_SUCCESS,
  DYNAMIC_DATA_POST_FAILURE,
  API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_SUCCESS,
  API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_FAILURE,
  API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_REQUEST,
} from 'common/types';
import {ENDPOINT_DYNAMIC_DATA} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

export default {
  postDataByGrant: (token, grantId, entityType) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DYNAMIC_DATA}grant/${grantId}/entityType/${entityType}`,
        headers: commonJwtHeader(),
        method: 'POST',
        types: [
          DYNAMIC_DATA_POST_REQUEST,
          DYNAMIC_DATA_POST_SUCCESS,
          DYNAMIC_DATA_POST_FAILURE,
        ],
      },
    };
  },
  getDataByGrant: (token, grantId, entityType) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DYNAMIC_DATA}grant/${grantId}/entityType/${entityType}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          DYNAMIC_DATA_GET_REQUEST,
          DYNAMIC_DATA_GET_SUCCESS,
          DYNAMIC_DATA_GET_FAILURE,
        ],
      },
    };
  },
  getDataByEntityId: (token, entityId) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DYNAMIC_DATA}entity/${entityId}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          DYNAMIC_DATA_GET_ENTITY_REQUEST,
          DYNAMIC_DATA_GET_ENTITY_SUCCESS,
          DYNAMIC_DATA_GET_ENTITY_FAILURE,
        ],
      },
    };
  },
  getDataByOrgIdByEntityType: (token, orgId, entityType) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DYNAMIC_DATA}organization/${orgId}/entityType/${entityType}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          DYNAMIC_DATA_GET_ORG_ENTITY_REQUEST,
          DYNAMIC_DATA_GET_ORG_ENTITY_SUCCESS,
          DYNAMIC_DATA_GET_ORG_ENTITY_FAILURE,
        ],
      },
    };
  },
  postData: (token, payload) => {
    return {
      [CALL_API]: {
        endpoint: ENDPOINT_DYNAMIC_DATA,
        headers: commonJwtHeader(),
        body: payload,
        method: 'POST',
        types: [
          DYNAMIC_DATA_POST_REQUEST,
          DYNAMIC_DATA_POST_SUCCESS,
          DYNAMIC_DATA_POST_FAILURE,
        ],
      },
    };
  },
  updateData: (token, payload) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DYNAMIC_DATA}entity/${payload.entityId}`,
        headers: commonJwtHeader(),
        body: payload,
        method: 'PUT',
        types: [
          DYNAMIC_DATA_POST_REQUEST,
          DYNAMIC_DATA_POST_SUCCESS,
          DYNAMIC_DATA_POST_FAILURE,
        ],
      },
    };
  },
  getGrantByOrganizationByProgramIds: (token, number, filter, orgProgram) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DYNAMIC_DATA}organization/${number}/entityType/grant?programIds=${orgProgram}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_REQUEST,
          API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_SUCCESS,
          API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_FAILURE,
        ],
      },
    };
  },
};
